<template>
  <div>
    <main-layout>
      <div class="content-wrap" v-loading="loading">
        <el-drawer
          custom-class="code-drawer"
          append-to-body
          :show-close="false"
          :destroy-on-close="true"
          :title="drawerTitle"
          :visible.sync="drawer"
          direction="rtl"
          :before-close="beforeClose"
        >
          <div class="drawer-wrap">
            <div class="content">
              <div class="pdf-data" :ref="'qrcode' + codeId">
                <img class="pdf-bj" :src="backImg" alt />
                <vue-qr
                  class="code-img"
                  :text="codeText"
                  :margin="0"
                  :logoCornerRadius="4"
                  colorDark="#000"
                  colorLight="#fff"
                  :logoSrc="logoImg"
                  :logoScale="0.2"
                  :size="540"
                  :callback="getQrCode"
                ></vue-qr>
              </div>
              <p class="code-text" v-show="storeName">{{ storeName }}</p>
              <p class="code-text jskpCode" v-show="jskpCode">{{ jskpCode }}</p>
            </div>
            <el-button
              type="primary"
              class="down-code"
              @click="downCode"
              size="small"
              >下载二维码码牌</el-button
            >
          </div>
        </el-drawer>
        <div class="shoptable-box">
          <search-form
            :treedata="treedata"
            :goReset="resetTog"
            @searchForm="searchForm"
            @resetForm="resetForm"
          ></search-form>
          <el-button
            v-if="userAuth.extOperation && treedata && treedata.length"
            class="el-button--add"
            size="small"
            @click="shopAdd"
            type="primary"
            >新增</el-button
          >
          <shop-table
            :tableData="tableData"
            :treedata="treedata"
            @goDelete="goDelete"
            @codeView="codeView"
            @codeSet="shopSet"
            :userAuth="userAuth"
          ></shop-table>
          <Paging
            layout="prev, pager, next, total, sizes, jumper"
            v-if="aCount > 10"
            :currentPage="pagObj"
            :total="aCount"
            :handleCurrentChange="handleCurrentChange"
            :handleSizeChange="handleSizeChange"
          ></Paging>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import vueQr from "vue-qr"; // 因用到背景图标
import MainLayout from "@/views/layout/mainlayout";
import Paging from "@components/public/paging";
import backImg from "../../../../src/assets/print_code_new.png";
import SearchForm from "./searchForm";
import ShopTable from "./table";

export default {
  name: "ShopSet",
  components: {
    MainLayout,
    Paging,
    vueQr,
    ShopTable,
    SearchForm,
  },
  data() {
    return {
      logoImg: require("@assets/print_logo.png"),
      codeVisible: false,
      tableData: [],
      currentPage: 1,
      aCount: 0,
      pCount: 20,
      status: true,
      isdn: true,
      backImg,
      current: 1,
      loading: true,
      jskpCode: "",
      qrurl: "https://jskp.jss.com.cn/k.action?kpdm=",
      treedata: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      qrcodeUrl: "",
      registerType: "", // 用户类型
      pagObj: {
        currentPage: 1,
        pageSize: 10,
      },
      drawer: false, // 抽屉开关
      storeName: "", // 抽屉名称
      codeId: "", // 抽屉ID
      codeText: "", // 抽屉二维码内容
      drawerTitle: "", // 抽屉标题
      submitLoading: false, // 正在提交中
      userAuth: {
        extOperation: true,
      },
      resetTog: true,
    };
  },
  mounted() {
    this.getAuth();
    this.getCode();
    this.getDepartment();
  },
  methods: {
    getAuth() {
      const registerType = sessionStorage.getItem("registerType");
      const myShowMenus = JSON.parse(sessionStorage.getItem("myShowMenusTips"));
      // 0：个人 1：企业
      if (registerType == 0) {
        this.userAuth = myShowMenus || {};
      }
    },
    shopAdd() {
      this.$router.push({ path: "shopSet" });
      this.$store.commit("setState", {
        shopDetailParams: "",
      });
    },

    shopSet(id) {
      this.$router.push({ path: "shopSet", query: { id } });
    },
    getCode() {
      this.api.post("payment/code.do", {}).then((res) => {
        if (res.code == "200") {
          this.jskpCode = res.data;
          this.search(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getDepartment() {
      // 获取部门信息
      this.api
        .post("juhe/query/getAllDepartmentList.do", {})
        .then(({ data, code, message }) => {
          if (code === 200) {
            this.treedata = data;
          } else {
            this.$message.error(message);
          }
        });
    },
    codeView(row) {
      this.drawer = true;
      this.drawerTitle = row.extNum == -1 ? "主机码" : "分机号" + row.extNum;
      this.storeName = row.storeName;
      this.codeId = row.id;
      let ext;
      if (row.extNum == -1) {
        ext = "";
      } else {
        ext = `&jh=${row.extNum}`;
      }
      this.codeText = this.qrurl + (this.jskpCode || "") + ext;
    },
    beforeClose() {
      this.drawer = false;
    },
    // 获取浏览器像素比 将 Canvas 宽高进行放大
    getPixelRatio(context) {
      const backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },

    getQrCode(qrcode) {
      this.qrcodeUrl = qrcode;
    },

    downCode() {
      const myCanvas = document.createElement("canvas");
      const width = 1240;
      const height = 1748;
      const context = myCanvas.getContext("2d");
      const ratio = this.getPixelRatio(context);
      myCanvas.style.width = width + "px";
      myCanvas.style.height = height + "px";
      myCanvas.width = width * ratio;
      myCanvas.height = height * ratio;
      const back = new Image();
      const qrImg = new Image();
      back.src = backImg;
      qrImg.src = this.qrcodeUrl;
      back.onload = () => {
        context.drawImage(back, 0, 0, width * ratio, height * ratio);
        context.drawImage(
          qrImg,
          350 * ratio,
          510 * ratio,
          540 * ratio,
          540 * ratio
        );
        myCanvas.toBlob((blob) => {
          const a = document.createElement("a");
          a.download = this.storeName || new Date().getTime();
          a.href = window.URL.createObjectURL(blob);
          a.click();
        });
      };

      // this.$nextTick(() => {
      //   const _this = this;
      //   domtoimage
      //     .toPng(this.$refs["qrcode" + this.codeId])
      //     .then(function(blob) {
      //       let saveUrl = blob;

      //       let a = document.createElement("a");

      //       document.body.appendChild(a);

      //       a.href = saveUrl;

      //       a.download = _this.storeName || new Date().getTime();
      //       a.click();
      //     });
      // });
    },
    searchForm(form) {
      this.search(form);
    },
    resetForm(form) {
      this.searchForm(form);
    },
    search(form) {
      this.loading = true;
      this.api
        .post("juhe/info/queryByCustomerId.do", { ...form, ...this.pagObj })
        .then((res) => {
          if (res.code == "200") {
            const { data } = res;
            this.loading = false;
            this.tableData = res.data.result || [];
            this.aCount = data.aCount;
            if (data.aCount > this.pagObj.pageSize) {
              this.isdn = false;
            } else {
              this.isdn = true;
            }
          } else {
            this.$message.error("系统错误");
          }
        });
    },
    handleSizeChange(val) {
      // 分页
      this.pagObj.pageSize = val;
      this.pagObj.currentPage = 1;
      this.search();
    },
    handleCurrentChange(val) {
      this.pagObj.currentPage = val;
      this.search();
    },
    goDelete(id) {
      this.$confirm("确定要删除这条数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .post("juhe/info/delCustomerExtById.do", {
            id,
          })
          .then((res) => {
            if (res.code == "200" && res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.pagObj.currentPage = 1;
              this.search();
            } else {
              this.$message.error("系统错误");
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
.shoptable-box {
  min-height: 350px;
  .el-switch__label.is-active {
    color: #606266;
  }

  .el-switch__label--left {
    margin-right: 12px;
    color: #606266;
  }

  .el-button--text {
    padding: 0;
    font-size: 14px;
    color: #409eff;
  }

  .el-button--add {
    margin-bottom: 16px;
    background-color: #409eff;
    width: 110px;
  }

  .el-button--add:hover {
    background-color: #3095fa;
  }

  .el-button--add:active {
    background-color: #167be1;
  }
}

.code-drawer {
  display: block !important;
  width: 484px !important;
  .el-drawer__header {
    margin-bottom: 0;
  }
  .el-drawer__body {
    height: 100%;
  }
  .down-code {
    height: 50px;
    border-radius: 0;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
<style scoped lang="scss">
.drawer-wrap {
  height: 100%;
  text-align: center;
  .content {
    padding: 0 30px;
    height: 80%;
    padding-bottom: 50px;
    overflow-y: auto;
  }
}
.pdf-data {
  display: inline-block;
  text-align: center;
  position: relative;
  width: 420px;
  height: 593px;
  margin-bottom: 8px;

  .pdf-bj {
    width: 100%;
    height: 100%;
    display: block;
  }

  .code-img {
    width: 180px;
    height: 180px;
    position: absolute;
    top: 175px;
    left: 120px;
  }
}

.code-text {
  width: 420px;
  margin: 0 auto 8px;
  display: -webkit-box;
  -webkit-box-pack: center;
  overflow: hidden;
  min-height: 18px;
  line-height: 18px;
  text-overflow: ellipsis;
  word-break: break-all;
  font-size: 16px;
  text-align: center;
}
.jskpCode {
  font-size: 14px;
  color: #606266;
}
</style>
